<template>
  <v-main>
    <router-view />
  </v-main>
</template>

<script setup lang="ts">
/**
 * A simple layout for pages that do not use the default navigation,
 * such as sign-in, forgot-password, etc.
 *
 * @author Alexander Funke
 * @lastChange 2025-09-18
 */
</script>
